<template>
<div id="contents" class="pink">
  <link href="https://fonts.googleapis.com/css?family=Noto+Sans+JP:400,700&display=swap&subset=japanese" rel="stylesheet">
  <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css"/>
  <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css"/>
  <div id="recruit_header">
    <router-link v-bind:to="{name: 'index', params : { link: true } }"><img src="../assets/img/common/recruit_2021/recruit_tv-asahi_logo.svg" class="tv-asahi_logo" alt="テレビ朝日映像"></router-link>
    <img @click="tag_list_show" src="../assets/img/common/recruit_2023/recruit_2023_logo.svg" class="recruit_2021_logo" alt="RECRUIT 2023">
    <div class="btn_list">
      <a class="sns_btn" v-bind:href="'https://www.instagram.com/tv_asahipro_saiyo/'" target="_blank"><img src="../assets/img/common/recruit_2021/sns_logo/Instagram_logo.svg" alt="Instagram"></a>
      <a class="sns_btn" v-bind:href="'http://twitter.com/share?url=' + current_url + '&text='+ this.$route.meta.title" target="_blank"><img src="../assets/img/common/recruit_2021/sns_logo/twitter_logo.svg" alt="Twitter"></a>
      <a class="sns_btn mr_16" v-bind:href="'https://www.facebook.com/sharer/sharer.php?u=' + current_url " target="_blank"><img src="../assets/img/common/recruit_2021/sns_logo/facebook_logo.png" alt="Facebook"></a>
      <a class="entry_btn" v-if="title_show == false" href="https://job.mynavi.jp/23/pc/search/corp93057/outline.html" target="_blank"><img src="../assets/img/common/recruit_2021/entry.svg" alt="エントリー"></a>
      <a class="requirements_btn" v-if="title_show == false" @click="open_model('', 'info', null)"><p>応募要項</p></a>
    </div>
  </div>
      <transition name="title">
        <div id="recruit_title_test" class="recruit_title" v-if="title_show && modal_show == false">
          <p id="apology_link"><router-link v-bind:to="{name: 'creator_bank_contact', hash: '#apology_text_link'}" target="_blank">【お詫び】弊社HP「クリエイターズバンク」登録募集における不具合のお詫びについて<br />※ 詳細は、テレビ朝日映像「クリエイターズバンク」ページにてご案内しております</router-link></p>
          <img class="title_logo" @click="title_show =! title_show" src="../assets/img/common/recruit_2022/recruit_title_logo_wide.png" width="1016">
          <div class="link_list">
            <div class="link_list_item" @click="title_show =! title_show">
              <div class="desc">
                <h3>新卒採用</h3>
                <p>2023年度新卒採用はこちら</p>
              </div>
              <div class="dest"><p>リクルートサイトへ</p></div>
            </div>
            <div class="link_list_item">
              <router-link v-bind:to="{name: 'creator_bank_contact'}">
                <div class="desc">
                  <h3>クリエイターズバンク</h3>
                  <p>弊社と一緒に、映像制作に取り組んでいただける<br />フリークリエイターを募集しています。</p>
                </div>
                <div class="dest"><p>応募サイト</p></div>
              </router-link>
            </div>
          </div>
        </div>
      </transition>
      <div :class="[tag_long_style ? 'long_tag_style' : 'wide_tag_style' ]">
        <div :class="[modal_show == false && this.grid_layout_status == 'grid_list_hidden' ? 'tag_area' : '' ]" v-show="title_show == false">
          <div class="tag_list" >
            <transition-group name="fade" v-show="modal_show == false && tag_show && title_show == false">
              <div class="tag_list_item"
                v-for="(tag, index) in hash_tag_list"
                :key="tag.id"
                :class="[tag.status + ' tag_style_' + index]"
                :style="{
                  'animation-timing-function': 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                  'animation-duration': 1.7 - index / moving_speed + 's',
                  'animation-delay': 0.5 + index / 12 + 's'
                }">
                <p class="tag_link" v-if="tag.tag_type != 'image' && tag.link_type == 'grid'"
                  v-on:click="show_posts(tag.id, tag.post_type, tag.api, tag.request_id)">
                  {{ tag.title }}
                </p>
                <p class="tag_link" v-if=" tag.tag_type != 'image' && tag.link_type == 'model'"
                  v-on:click="open_model(tag.request_id, tag.model_layout, null)">
                  {{ tag.title }}
                </p>
                <p class="tag_link" v-if="tag.tag_type != 'image' && tag.link_type == 'direct'">
                  <router-link v-bind:to="{name: tag.request_url}" v-bind:select_category="tag.request_id" >{{ tag.title }}</router-link>
                </p>
                <p class="tag_link" v-if="tag.tag_type != 'image' && tag.link_type == 'external_link'">
                  <a :href="tag.request_url" v-bind:select_category="tag.request_id" target="_blank">{{ tag.title }}</a>
                </p>
                <p class="tag_link" v-if="tag.tag_type == 'image' "
                  v-on:click="show_posts(tag.id, tag.post_type, null, tag.request_id)">
                  <img :src="tag.title">
                </p>
              </div>
            </transition-group>
            <p @click="hidden_posts()" :class="[back_btn]" v-if="modal_show == false && modal_change == false && close_text" class="back_btn">もどる ×</p>
            <gridlist :grid_layout_status="this.grid_layout_status"
              :modal_show="this.modal_show"
              :post_type="this.post_type"
              :modal_change="this.modal_change"
              :api="this.api"
              :request_id="this.request_id"
              @request_post_type="reload_posts"
              @modal_show="open_model" >
            </gridlist>
            <transition name="fade">
              <info @close_icon="close_model" v-if="modal_show === 'info'" />
              <movie @close_icon="close_model" :post_type="this.post_type" @reload_model="reload_model" v-if="modal_show === 'movie'" />
              <young @close_icon="close_model" :post_type="this.post_type" :link="this.anchor_link" @reload_model="reload_model" v-if="modal_show === 'young'" />
              <point @close_icon="close_model" v-if="modal_show === 'point'" />
              <rorando @close_icon="close_model" v-if="modal_show === 'rorando'" />
              <corona @close_icon="close_model" v-if="modal_show === 'corona'" />
              <pinch @close_icon="close_model" v-if="modal_show === 'pinch'" />
              <top_message @close_icon="close_model" v-if="modal_show === 'top_message'" />
              <welfare @close_icon="close_model" v-if="modal_show === 'welfare'" />
              <div class="model_wrapper" v-if="['players', 'program', 'creator-agency', 'company', 'companyhistory', 'awards', 'sustainability', 'comp', 'drone', 'photographing','link'].includes(modal_show) ">
                <div v-show="close_icon" class="close_icon">
                  <img src="../assets/img/common/recruit_2021/close_icon.svg" @click="close_model"/>
                </div>
                <players v-if="modal_show === 'players'" />
                <program v-if="modal_show === 'program'" />
                <tapcast v-if="modal_show === 'creator-agency'" />
                <company v-if="modal_show === 'company'" />
                <companyhistory v-if="modal_show === 'companyhistory'" />
                <awards v-if="modal_show === 'awards'" />
                <sustainability v-if="modal_show === 'sustainability'" />
                <comp v-if="modal_show === 'comp'" />
                <drone v-if="modal_show === 'drone'" />
                <photographing v-if="modal_show === 'photographing'" />
              </div>
            </transition>
          </div> <!-- tag_list end -->
        </div>
      </div>
      <div id="footer" v-show="title_show == false">
        <p id="footer_contact_btn" ><router-link v-bind:to="{name: 'contact', params: { link: true } }" class="btn btn-black">CONTACT</router-link></p>
        <div id="footer_inner">
          <p class="policy"><router-link v-bind:to="{name: 'privacypolicy', params : { link: true } }">PRIVACY POLICY</router-link></p>
          <p class="copy">&copy; 2019 テレビ朝日映像</p>
        </div><!-- #footer_inner -->
      </div>

</div><!-- #contents -->
</template>
<script>
import gridlist from './recruit_grid_list.vue'
import info from './recruit_info.vue'
import movie from './recruit_movie.vue'
import young from './recruit_young.vue'
import point from './recruit_point.vue'
import rorando from './recruit_rorando.vue'
import welfare from './recruit_welfare.vue'
import corona from './recruit_corona.vue'
import pinch from './recruit_pinch.vue'
import top_message from './recruit_top_message.vue'
import players from './players_show.vue'
import program from './program_show.vue'
import tapcast from './tapcast_show.vue'
import company from './company_index.vue'
import companyhistory from './history_index.vue'
import awards from './awards_index.vue'
import sustainability from './sustainability_index.vue'
import comp from './finance_index.vue'
import drone from './drawn_index.vue'
import photographing from './photographing_index.vue'
import hash_tag_list from './js/recruit_tags_2023.json'
export default {
  name: 'recruit_tags',
  data() {
    return {
      tag_show: true,
      title_show: false,
      api_url: this.$parent.api_base_url+'/api/recruit/index.php',
      api_base_url: this.$parent.api_base_url,
      loading: false,
      error: null,
      show: "",
      choice_tag: null,
      moving_speed: 18,
      back_btn: "back_hidden",
      hash_tag_list: hash_tag_list,
      grid_layout_status: 'grid_list_hidden',
      post_type: null,
      link_type: null,
      model_layout: null,
      api: null,
      request_id: null,
      modal_show: false,
      anchor_link: null,
      modal_change: false,
      close_icon: false,
      close_text: false,
      tag_long_style: false,
      resize_timeout: false,
      scroll_timeout: false,
      current_url: location.origin
    }
  },
  watch: {
    title_show: function(){
      if (this.title_show == false){
        history.pushState(null, null, null);
      }
    },
    modal_show: function(){
      if (this.modal_show == 'rorando'){
        $('#contents').removeClass('pink');
        $('#contents').addClass('blue');
      } else {
        $('#contents').removeClass('blue');
        $('#contents').addClass('pink');
      }
      if (this.modal_show == 'pinch'){
        $('#contents').removeClass('pink');
        $('#contents').addClass('deep_blue');
      } else {
        $('#contents').removeClass('deep_blue');
        $('#contents').addClass('pink');
      }
    }
  },
  components: {
    gridlist,
    movie,
    young,
    info,
    point,
    rorando,
    welfare,
    corona,
    pinch,
    top_message,
    tapcast,
    program,
    players,
    company,
    companyhistory,
    awards,
    sustainability,
    comp,
    drone,
    photographing,
  },
  beforeRouteLeave (to, from, next) {
    if ( this.title_show == false && to.params.link === undefined) {
      if (to.name == 'players_show'){
        this.modal_show = 'players'
        this.reload_model(to.params.id, this.modal_show)
      } else if (to.name == 'works_program_show'){
        this.modal_show = 'program'
        this.reload_model(to.params.id, this.modal_show)
      } else if(to.params.company === undefined){
        this.tag_list_show()
        next(false);
      } else {
        this.modal_show = to.params.company
        this.$route.params.company = this.modal_show
        to.params.id = null
        this.open_model(to.params.id, this.modal_show, null)
      }
      next(false);
    } else {
      next();
    }
  },
  mounted () {
    this.post_type = 'all'
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    scrollTo(0, 0)
    for ( var i = 0; i < this.hash_tag_list.length; i++ ) {
      this.hash_tag_list[i].status = "slide_in"
    }
    this.handle_resize()
    var scroll_show = false
    if ( this.title_show == true ) {
      // $(window).on('scroll',function () {
      //   if(scroll_show == false){
      //     window.scrollTo(0,0)
      //     scroll_show = true
      //     $('.recruit_title').click();
      //     $('body').addClass('no_scroll');
      //     setTimeout(() => {
      //       $('body').removeClass('no_scroll');
      //     }, 200);
      //   }
      // });
    }
    $(window).on("popstate", function (event) {
      if ( !$('#recruit_title_test').length ){
        $('.recruit_2021_logo').click();
      }
      $('title').html("テレビ朝日映像新卒リクルートサイト2023 | テレビ朝日映像")
      if (!event.originalEvent.state) {
        history.pushState(null, null, null);
        return;
      }
    });
  },
  created() {
    window.addEventListener('resize', this.handle_resize)
    //  $(window).on('scroll', this.scroll_event)
    // setTimeout(() => {
    //   window.addEventListener('scroll', this.scroll_event)
    //   scrollTo(0, 0)
    // }, 500);
  },
  destroyed() {
    window.removeEventListener('resize', this.handle_resize)
  },
  methods: {
    reload_posts(post_type){
      var target = this.hash_tag_list.find((tag) => {
        return (tag.post_type == post_type);
      });
      for ( var i = 0; i < this.hash_tag_list.length; i++ ) {
        if (this.hash_tag_list[i].id == this.choice_tag){
          this.hash_tag_list[i].status = "return"
        }
      }
      this.modal_show = false
      this.anchor_link = false
      this.back_btn = "back_hidden"
      this.grid_layout_status = "grid_list_hidden"
      setTimeout(() => {
        this.show_posts(target.id, post_type, null, null);
      }, 300)
    },
    reload_model(post_id, layout){
      this.modal_change = true
      this.$route.params.id = null
      this.modal = false
      this.modal_show = false
      this.anchor_link = false
      this.tag_show = false
      scrollTo(0, 0)
      setTimeout(() => {
        this.open_model(post_id, layout , null);
      }, 300)
    },
    tag_list_show(){
      scrollTo(0, 0)
      this.title_show = false
      this.modal_show = false
      this.modal_change = false
      this.back_btn = "back_hidden"
      this.grid_layout_status = "grid_list_hidden"
      this.close_text = false
      this.tag_show = true
      $('.tag_list').css({
        'max-height':'56.9vw'
      });
      for ( var i = 0; i < this.hash_tag_list.length; i++ ) {
        this.hash_tag_list[i].status = "slide_in"
      }
    },
    show_posts(tag_id, post_type, api, request_id){
      scrollTo(0, 0)
      this.moving_speed = 20
      for ( var i = 0; i < this.hash_tag_list.length; i++ ) {
        if (this.hash_tag_list[i].id == tag_id){
          this.hash_tag_list[i].status = "choice"
          this.choice_tag = tag_id
          this.request_tag_id = tag_id
          this.post_type = post_type
          this.api = api
          this.request_id = request_id
          this.close_text = true
        } else {
          this.hash_tag_list[i].status = "hidden"
        }
      }
      this.back_btn = "back_show"
      this.grid_layout_status = "grid_list_show"
      $('.tag_list').css({
        'max-height':'none'
      });
    },
    hidden_posts(){
      scrollTo(0, 0)
      for ( var i = 0; i < this.hash_tag_list.length; i++ ) {
        if (this.hash_tag_list[i].id == this.choice_tag){
          this.hash_tag_list[i].status = "return"
        } else {
          this.hash_tag_list[i].status = "show"
        }
      }
      this.modal_change = false
      this.modal_show = false
      this.anchor_link = false
      this.back_btn = "back_hidden"
      this.grid_layout_status = "grid_list_hidden"
      this.close_text = false
      $('.tag_list').css({
        'max-height':'56.9vw'
      });
    },
    open_model(post_id, layout, link) {
      if (['company', 'companyhistory', 'awards', 'sustainability', 'comp'].includes(layout)){
      } else {
        scrollTo(0, 0)
      }
      this.$route.params.id = post_id
      this.modal = true
      this.title_show = false
      this.modal_show = layout
      this.anchor_link = link
      if (this.request_tag_id == true ){
        for ( var i = 0; i < this.hash_tag_list.length; i++ ) {
          if (this.hash_tag_list[i].id == this.choice_tag){
            this.hash_tag_list[i].status = "choice_hidden"
          } else {
            this.hash_tag_list[i].status = "hidden"
          }
        }
      }
      if (['players', 'program', 'creator-agency', 'company', 'companyhistory', 'awards', 'sustainability', 'comp', 'drone', 'photographing' ].includes(layout)){
        this.close_icon = true
      }
      $('.tag_list').css({
        'max-height':'none'
      });
    },
    close_model() {
      scrollTo(0, 0)
      this.$route.params.id = null
      this.modal = false
      this.modal_show = false
      this.modal_change = false
      this.close_icon = false
      this.tag_show = true
      this.$route.params.company = undefined
      if ( this.grid_layout_status == 'grid_list_show' ){
        this.hash_tag_list[ this.request_tag_id ].status = 'choice'
      }else{
        $('.tag_list').css({
          'max-height':'56.9vw'
        });
        for ( var i = 0; i < this.hash_tag_list.length; i++ ) {
          this.hash_tag_list[i].status = "slide_in"
        }
      }
    },
    // scroll_event(){
    //   clearTimeout( this.scroll_timeout );
    //   this.scroll_timeout = setTimeout(() => {
    //     if( this.title_show == true){
    //       this.title_show = false
    //     }
    //   }, 500);
    // },
    handle_resize() {
      if ( this.grid_layout_status != 'grid_list_show' && this.request_tag_id){
        this.hash_tag_list[this.request_tag_id].status = "now_show";
      }
      clearTimeout( this.resize_timeout );
      this.resize_timeout = setTimeout(() => {
        if (window.innerWidth <= 900 && this.tag_long_style == false){
          this.tag_long_style = true
          this.hash_tag_list.sort(function(a,b){
            if(a.long_style_id < b.long_style_id) return -1;
            if(a.long_style_id > b.long_style_id) return 1;
            return 0;
          });
        } else if (window.innerWidth <= window.innerHeight && this.tag_long_style == false){
          this.tag_long_style = true
          this.hash_tag_list.sort(function(a,b){
            if(a.long_style_id < b.long_style_id) return -1;
            if(a.long_style_id > b.long_style_id) return 1;
            return 0;
          });
        } else if (window.innerWidth > 900 && this.tag_long_style == true){
          this.tag_long_style = false
          this.hash_tag_list.sort(function(a,b){
            if(a.id < b.id) return -1;
            if(a.id > b.id) return 1;
            return 0;
          });
        }
      }, 500);
    }
  },
}
</script>
<style lang="sass">
  @import "../assets/stylesheet/recruit2023/hash_tag.sass"
</style>
<style scoped lang="sass">
@keyframes tag_slide_in
  0%
    display: block
  100%
    transform: translateY(0vw)

@keyframes tag_hidden
  0%
    opacity: 1
  20%
    opacity: 0
  21%
    transform: translateY(0vw)
  100%
    opacity: 0
    transform: translateY(100vw)
@keyframes tag_open
  0%
    opacity: 0
    transform: translateY(0vw)
  100%
    opacity: 1
@keyframes tag_now_open
  0%
    opacity: 1
    transform: translateY(0vw)
  100%
    opacity: 1

@keyframes tag_choice
  0%
    width: auto
  100%
    opacity: 1
    top: 2.1vw
    left: 2.1vw
    width: auto
@keyframes tag_choice_hidden
  0%
    width: auto
    opacity: 0
    top: 2.1vw
    left: 2.1vw
  100%
    opacity: 0
    top: 2.1vw
    left: 2.1vw
    width: auto
@keyframes tag_choice_text
  0%
    // allの動き
    height: 18vw
  80%
    font-size: 5.1vw
    height: 7vw
  100%
    font-size: 5.1vw
    height: 7vw
@keyframes tag_return
  0%
    top: 2.1vw
    left: 2.1vw
  100%
@keyframes tag_return_text
  0%
    font-size: 5.1vw
    height: 7vw
  99%
    // allの動き
    height: 18vw
  100%
@keyframes scroll_icon_anime
  0% 
    opacity: 1
    -webkit-transform: translateY(0)
    transform: translateY(0)
  100% 
    opacity: 0.5
    -webkit-transform: translateY(-8px)
    transform: translateY(-8px)

#recruit_header
  margin-top: 20px
  height: 45px
  width: 100%
  z-index: 100
  .tv-asahi_logo
    width: 201px
    height: 26px
    margin-top: 9px
    margin-left: 25px
    cursor: pointer
    transition: .3s all
    &:hover
      transform: scale(1.1)
  .recruit_2021_logo
    width: 143px
    height: 22px
    margin-top: 13px
    margin-left: calc(50vw - 310px)
    cursor: pointer
    transition: .3s all
    &:hover
      transform: scale(1.1)
  .btn_list
    float: right
    margin-right: 17px
    a
      float: left
    .entry_btn
      width: 12.5vw
      max-width: 175px
      height: 45px
      background: #F5FF00 0% 0% no-repeat padding-box
      border-radius: 25px
      display: inline-block
      color: #FF7689
      line-height: 31px
      margin-right: 11px
      cursor: pointer
      img
        width: 71px
        height: 20px
        margin: 15px auto
        display: block
    .requirements_btn
      width: 12.5vw
      max-width: 175px
      height: 45px
      background: #FFFFFF 0% 0% no-repeat padding-box
      border-radius: 25px
      display: inline-block
      margin-right: 17px
      cursor: pointer
      &:last-child
        margin-right: 0px
      p
        font-family: 'Noto Sans JP', sans-serif
        font-weight: 700
        font-size: 18px
        line-height: 45px
        letter-spacing: 0.23em
        text-align: center
        color: #FF7689
    .sns_btn
      margin-right: 10px
      cursor: pointer
      img
        margin-top: 10px
        width: 26px
        height: 26px
    .mr_16
      margin-right: 16px

.slide_in
  animation-name: tag_slide_in
  animation-fill-mode: forwards
  transform: translateY(70vw)

.choice
  animation-name: tag_choice
  animation-fill-mode: forwards
  animation-delay: 0s !important
  p
    animation-name: tag_choice_text
    animation-fill-mode: forwards
    animation-duration: 0.5s
    animation-delay: 0s !important
    img
      width: auto !important

.choice_hidden
  animation-name: tag_choice_hidden
  animation-fill-mode: forwards
  animation-delay: 0s !important
  p
    animation-name: tag_choice_text
    animation-fill-mode: forwards
    animation-duration: 0.5s
    animation-delay: 0s !important
    img
      width: auto !important
.show
  animation-name: tag_open
  animation-fill-mode: forwards
  animation-delay: 0s !important
  opacity: 0

.now_show
  animation-name: tag_now_open
  animation-fill-mode: forwards
  animation-delay: 0s !important
  opacity: 1

.hidden
  animation-name: tag_hidden
  animation-fill-mode: forwards
  animation-duration: 0.2s
  animation-delay: 0s !important

.return
  animation-name: tag_return
  animation-fill-mode: forwards
  animation-duration: 2s
  animation-delay: 0s !important
  p
    animation-name: tag_return_text
    animation-fill-mode: forwards
    animation-duration: 0.5s
    animation-delay: 0s !important

@keyframes back_show
  0%
    opacity: 0
  100%
    opacity: 1
@keyframes back_hidden
  0%
    opacity: 1
  100%
    opacity: 0

.back_btn
  position: absolute
  top: 3.6vw
  left: 90.2vw
  font-family: 'Noto Sans JP', sans-serif
  font-weight: 700
  font-size: 1.6vw
  color: #FFF
  cursor: pointer
.back_show
  animation-name: back_show
  animation-fill-mode: forwards
  animation-duration: 1.3s
.back_hidden
  animation-name: back_hidden
  animation-fill-mode: forwards
  animation-duration: 1s

.close_icon
  width: 1000px
  margin: 0 auto
  position: absolute
  top: -54px
  margin-bottom: 25px
  cursor: pointer
  img
    width: 40px
    height: 40px
    margin-left: 960px



@keyframes post_list_show
  0%
  100%
    transform: translateY(0vw)
@keyframes post_list_hidden
  0%
    transform: translateY(0vw)
  100%
    transform: translateY(100vw)

.post_list
  transform: translateY(100vw)
.post_list_show
  animation-name: post_list_show
  animation-fill-mode: forwards
.post_list_hidden
  animation-name: post_list_hidden
  animation-fill-mode: forwards
  animation-delay: 0s !important
#contents
  min-height: 100vh
  width: 100%
  overflow: hidden
  &.pink
    background-color: #ff7689
  &.blue
    background-color: #02ACC3
  &.deep_blue
    background-color: #003A6F
.recruit_title
  width: 100vw
  height: calc((100vh - 142px) - 49px )
  min-height: 600px
  #apology_link
    display: table
    margin: 40px auto 0
    padding: 0 20px
    a
      display: block
      font-size: 22px
      font-weight: bold
      line-height: 1.8
      color: #fff
      transition: .3s all
      &:hover
        text-decoration: none
  .title_logo
    margin: 0 auto
    margin-top: 62px
    display: block
    width: 72.6vw
    cursor: pointer
    transition: .3s all
  .scroll_icon
    margin-left: calc(50vw - 4vh)
    margin-top: 4.6vh
    display: block
    width: 9.2vh
    height: 4.4vh
    animation: scroll_icon_anime 0.8s cubic-bezier(0.215, 0.61, 0.355, 1) 0s infinite alternate
  .link_list
    display: flex
    justify-content: space-between
    width: 72.6vw
    margin: 88px auto 0
    &_item
      overflow: hidden
      width: 33.5vw
      border: 3px solid #fff
      border-radius: 17px
      font-family: 'Noto Sans JP', sans-serif
      cursor: pointer
      transition: .3s all
      &:hover
        transform: scale(1.1)
      a
        text-decoration: none
      .desc
        height: 101px
        padding: 33px 0 23px
        background: #fff
        color: #FF7689
        text-align: center
        h3
          font-size: 30px
          font-weight: 700
          line-height: 1
          letter-spacing: 0.1em
        p
          margin: 23px 0 0
          font-size: 15px
          font-weight: 700
          line-height: 1.6em
          letter-spacing: 0.15em
      .dest
        display: flex
        align-items: center
        justify-content: space-between
        height: 60px
        padding: 0 18px 0 22px
        &::after
          content: ""
          display: block
          width: 11px
          height: 17px
          background-image: url('../assets/img/common/recruit_2022/white_arrow.png')
          background-size: cover
        p
          font-size: 18px
          font-weight: 700
          letter-spacing: 0.15em
          color: #fff
.tag_list
  position: relative
  .tag_link
    transition: .3s all
    &:hover
      transform: scale(1.1)
  &_item
    display: flex
    position: absolute
    p
      font-family: 'Noto Sans JP', sans-serif
      font-weight: 700
      line-height: 1
      color: #FFF
      display: block
      white-space: nowrap
      cursor: pointer
      width: 100%
      img
        max-width: 100%
        max-height: 100%
    a
      font-family: 'Noto Sans JP', sans-serif
      font-weight: 700
      line-height: 1
      text-decoration: none
      color: #FFF
      display: block
      white-space: nowrap
      cursor: pointer
      width: 100%

.post_container
  width: 96.2vw
  margin: 0 auto
  margin: 14vw 1.7vw 2.4vw 2.1vw
  position: relative
  &:after
    clear: both
    display: block
    content: ""
  .left_list
    float: left
    width: 70vw
    .tmb_medium
      float: left
      width: 34.3vw
      height: 19.4vw
      &:nth-child(2)
        margin-left: 1.4vw
    .tmb_large
      float: left
      width: 70vw
      height: 39.4vw
      margin-top: 1.4vw
  .right_list
    float: left
    width: 24.8vw
    margin-left: 1.2vw
    .tmb_small
      float: left
      width: 24.8vw
      height: 13.8vw
      margin-top: 1.6vw
      &:first-child
        margin-top: 0vw

  .item
    border-radius: 8px
    overflow: hidden
    position: relative
    background-color: #fff
    img
      width: 100%
      overflow: hidden
      position: absolute
      top: 50%
      left: 50%
      -webkit-transform: translate(-50%, -50%)
      transform: translate(-50%, -50%)
      animation: steps(5) infinite

.title-leave
  opacity: 1
.title-leave-active
  transition: opacity .3s
.title-leave-to
  opacity: 0

.fade-enter-active, .fade-leave-active
  transition: opacity .5s
.fade-enter, .fade-leave-to
  opacity: 0


#footer
  padding: 42px 0px 12px
  background: #000
  #footer_contact_btn
    text-align: center
    padding: calc((100vh - 216px - 52vw) / 2)
    .btn
    a
      width: 305px
      line-height: 45px
      font-family: 'Ropa Sans', sans-serif
      letter-spacing: 0.1em
  #footer_inner
    padding: 0px 15px
    display: flex
    justify-content: space-between
    align-items: flex-end
    height: 60px
    a
      color: #fff
      font-size: 13px
    .copy
      font-size: 13px
      color: #fff
      font-family: 'Ropa Sans', sans-serif
@media screen and (max-width:1200px)
  .recruit_title
    .link_list
      &_item
        .desc
          h3
            font-size: 28px
          p
            font-size: 12px
@media screen and (max-width:1000px)
  #recruit_header
    .recruit_2021_logo
      margin-top: 12px
      margin-left: 7px
  #footer
    padding: 42px 0 12px 0
    #footer_contact_btn
      padding: calc((100vh - 742px) / 2)
      .btn
      a
    #footer_inner
      align-items: flex-end
      height: 60px
      a
      .copy
@media screen and (max-width:900px)
  #footer
    padding: 42px 0 12px 0
    #footer_contact_btn
      padding: calc((100vh - 102.4vw - 216px) / 2)
      .btn
      a
    #footer_inner
      align-items: flex-end
      height: 60px
      a
      .copy
@media screen and (min-width:1000px) and (orientation: portrait)
  #footer
    padding: 42px 0 12px 0
    #footer_contact_btn
      padding: calc((100vh - 102.4vw - 216px) / 2)
      .btn
      a
    #footer_inner
      align-items: flex-end
      height: 60px
      a
      .copy
</style>
<style>
  .model_wrapper
  {
    background-color: #FFF;
    padding-top: 20px;
    width: 1000px;
    margin: 160px auto 64px;
    position: relative;
  }
  .model_wrapper #contents
  {
    background-color: unset;
  }
  .model_wrapper .page_close
  {
    display: none;
  }
  .model_wrapper #page_nav p:first-child
  {
    left: 60px !important;
  }
  .model_wrapper #page_nav p:last-child
  {
    right: 60px !important;
  }
  .model_wrapper #works_program_show_body
  {
    overflow: hidden;
  }
  .model_wrapper #works_program_show_main
  {
    padding: 0 0 100px;
  }
  .model_wrapper #works_program_show_main_img img
  {
    min-height: 360px !important;
  }
  .model_wrapper #tapcast_contents #page_nav
  {
    display: none;
  }
  .model_wrapper .page_main_contents
  {
    width: 925px;
  }
  .model_wrapper #players_show_other_palyer
  {

  }
  .model_wrapper #players_show_other_palyer .other_player_image
  {
    width: 300px !important;
    height: 169px !important;
  }
  .model_wrapper .player_card_inner h3 a span:first-child
  {
    font-size: 17px !important;
  }
  .model_wrapper .player_card_inner h3 a span:last-child
  {
    font-size: 11px !important;
  }
  .model_wrapper #players_show_other_palyer_inner .player_card .player_num img
  {
    width: 21px !important;
    height: 32px !important;
  }
  .model_wrapper #players_contents
  {
    padding: 44px 0 0 0;
  }
  .model_wrapper #company_awards .page_sublink
  {
    padding: 50px 0px 120px !important;
  }
    .model_wrapper #company_finance .page_sublink
  {
    padding: 50px 0px 120px !important;
  }
  .model_wrapper .page_contents
  {
    width: 960px;
    margin-top: 0;
    padding: 60px 20px 0;
    background-color: #FFF;
  }
</style>


// WEBPACK FOOTER //
// src/components/recruit_2023.vue